// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/dead-leads/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/dead-leads/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Dead Leads" })
  return <Page />
}
